import Store from "../../../../utils/store";
import Event from "../../../../utils/event";
import {SYSTEM_EVENTS} from "../../../../events/events";
import {GNWP_SOURCES} from "../../../../components/external_links/external_links_consts";
import USBaseRegulation from "../us/us_base_regulation";
import {REGULATION_CODE_TYPES} from "../../regulation_const";
import BaseComponent from "../../../../base/base_component";
import MichiganResponsibleGamingIconsController
    from "../../../../components/regulation_components/us/michigan/michigan_responsible_gaming_icons_controller";

export default class MichiganRegulation extends USBaseRegulation {
    static CLASS = 'MichiganRegulation';

    protected _getRegulationType(): number {
        return REGULATION_CODE_TYPES.MICHIGAN;
    }

    getResponsibleGamingIconsComponent(params: any): BaseComponent {
        return MichiganResponsibleGamingIconsController.create(params);
    }

    stepsBeforeOpenLoginAndRegistration():Promise<void> {
        return new Promise((resolve, reject) => {
            const STATE_POPUP_KEY = 'state-popup';
            if(Store.get(STATE_POPUP_KEY)) {
                return resolve();
            }
            return this.serviceFactory.orbitComponentRenderService().showLocationPopup({
                stateName: "Michigan",
                onStateSelect: ()=> {
                    Store.set(STATE_POPUP_KEY, true);
                    return resolve();
                },
                onStateNotInListClick: ()=> {
                    this.onStateNotInListClickHandler();
                    reject();
                },
                onMessageClosed: ()=> {
                    Event.fire(SYSTEM_EVENTS.LOCATION_POPUP_CLOSED);
                    return reject();
                }
            });
        });
    }

    onStateNotInListClickHandler() {
        this.serviceFactory.windowService().redirect(this.serviceFactory.skinService().getWrongLocationDetectionPath());
    }

    shouldRefreshTokenOnAppOpen(){
        return true;
    }

    runConditionsBeforeOpenLink(source: string):Promise<void> {
        if(source !== GNWP_SOURCES.MEMBERSHIP) {
            return Promise.resolve();
        }

        return this.stepsBeforeOpenLoginAndRegistration();
    }
}